<script setup lang="ts">
import { formatFilesize } from '#layers/assets/utils/format-filesize';

defineProps<{
	file: File;
}>();
</script>

<template>
	<div class="flex min-w-0 items-center gap-2">
		<FileTypeIcon :file class="h-10 shrink-0" />
		<div class="flex min-w-0 flex-col text-sm">
			<DTextOverflow class="font-medium" :text="file.name" />
			<p class="truncate text-muted">
				{{ formatFilesize(file.size) }}
			</p>
		</div>
	</div>
</template>
